// AppShell - Main layout wrapper with header and navigation
import { Outlet } from 'react-router-dom';
import { AppShell as MantineAppShell } from '@mantine/core';
import { Header } from '../Header/Header';

export const AppShell = () => {
  return (
    <MantineAppShell header={{ height: 60 }} padding="md">
      <MantineAppShell.Header>
        <Header />
      </MantineAppShell.Header>

      <MantineAppShell.Main>
        <Outlet />
      </MantineAppShell.Main>
    </MantineAppShell>
  );
};
